import React, { useState } from 'react'
import { MentorRequestForEvent } from 'types/mentorRequest/mentorRequest'
import { Form, Input, FormInstance } from 'antd'
import { useUpdateMentorRequestForEvent } from 'api/Event/MentorRequest'
import { myStore } from 'state/store'
import ButtonSpinner from 'components/global/ButtonSpinner'

interface OtherNotesProps {
  form: FormInstance
  prevData: MentorRequestForEvent
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
}

const OtherNotes: React.FC<OtherNotesProps> = ({
  prevData,
  form,
  setCurrentStep,
  setOpenModal,
}) => {
  const { mutate: updateMentorRequestForEventMutation, isLoading } =
    useUpdateMentorRequestForEvent()
  const [loadingButton, setLoadingButton] = useState<'submit' | 'draft' | null>(
    null,
  )

  const formSchema = {
    additionalNotes: prevData?.additionalNotes || '',
  }

  const hanldeBack = () => {
    setCurrentStep(1)
  }

  const handleFinish = (values: any, status: 'active' | 'draft') => {
    setLoadingButton(status === 'active' ? 'submit' : 'draft')
    const payload = {
      additionalNotes: values.additionalNotes,
      status: status,
    }
    updateMentorRequestForEventMutation(
      {
        payload,
        requestId: prevData._id,
      },
      {
        onSuccess: () => {
          setLoadingButton(null)
          setOpenModal(false)
        },
        onError: () => {
          setLoadingButton(null)
        },
      },
    )
  }

  return (
    <>
      <div className="mt-20px">
        <h3 className="text-16 w-600">Would you like to add something else?</h3>
        <Form
          form={form}
          initialValues={formSchema}
          layout="vertical"
          onFinish={values => handleFinish(values, 'active')}
        >
          <div className="mt-15px">
            <Form.Item name="additionalNotes">
              <Input.TextArea
                placeholder="Tell us more what would you like to add..."
                className="h-100px"
                rows={10}
              />
            </Form.Item>
            <div className="flex mt-20px gap-20px justify-between align-center">
              <button className={`btn-secondary`} onClick={hanldeBack}>
                Back
              </button>
              <button
                type="submit"
                className={`btn-secondary`}
                disabled={loadingButton !== null}
              >
                {loadingButton === 'submit' ? (
                  <ButtonSpinner size={20} color="#000" />
                ) : (
                  'Submit request now'
                )}
              </button>
              <button
                type="button"
                className={`prim-btn`}
                disabled={loadingButton !== null}
                onClick={() =>
                  form
                    .validateFields()
                    .then(values => handleFinish(values, 'draft'))
                }
              >
                {loadingButton === 'draft' ? (
                  <ButtonSpinner size={20} color="#000" />
                ) : (
                  'Submit request on event post'
                )}
              </button>
            </div>
          </div>
        </Form>
      </div>
    </>
  )
}

export default OtherNotes
